
export enum PageSizes {
    a4p = 'a4-portrait',
    a4l = 'a4-landscape',
    wide8 = '8.5-wide-paper',
    wide11 = '11-wide-paper',
    real = 'WYSIWYG'
}
export type Orientation = 'p' | 'portrait' | 'l' | 'landscape'

export const getWidthInchPage = (format: PageSizes): [number, Orientation] => {
    switch (format) {
        case PageSizes.a4p:
            return [8.27, 'p']
        case PageSizes.a4l:
            return [11.69, 'l']
        case PageSizes.wide11:
            return [11, 'p']
        case PageSizes.wide8:
            return [8.5, 'p']
        default:
            return [13, 'p']
    }
}